/*
  BBDP - Wishlist (2026-10-06)
  Favoris gardes dans le navigateur (localStorage), sans compte client.
  Charge en differe par snippets/bbdp-wishlist-head.liquid.
  Aucun appel reseau sur les grilles : la fiche d'un produit n'est lue
  qu'au clic sur un coeur (pour Klaviyo) et sur la page /pages/wishlist.
*/
(function () {
  'use strict';
  if (window.BBDPWishlist) return;

  var KEY = 'bbdp_wishlist_v1';
  var MAX = 100;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var HEART_PATH = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  var cfg = window.BBDPWishlistConfig || {};
  var S = cfg.strings || {};
  var root = String(cfg.root || '/');
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var memory = [];
  var cache = {};

  function t(key, fallback) {
    return S[key] || fallback;
  }

  /* ---------- Stockage ---------- */

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (i) {
        return i && typeof i.h === 'string' && i.h;
      });
    } catch (e) {
      return memory.slice();
    }
  }

  function write(list) {
    memory = list.slice(0, MAX);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(memory));
    } catch (e) {
      /* stockage indisponible : la liste vit le temps de la page */
    }
  }

  function has(handle) {
    return read().some(function (i) {
      return i.h === handle;
    });
  }

  function add(handle, id) {
    var list = read().filter(function (i) {
      return i.h !== handle;
    });
    list.unshift({ h: handle, id: id || null, t: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(
      read().filter(function (i) {
        return i.h !== handle;
      })
    );
  }

  /* ---------- Boutons ---------- */

  function heartIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', HEART_PATH);
    svg.appendChild(path);
    return svg;
  }

  function setButton(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? t('remove', 'Retirer des favoris') : t('add', 'Ajouter aux favoris'));
  }

  function makeButton(handle, id, source, on) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bbdp-wish-btn';
    btn.setAttribute('data-handle', handle);
    if (id) btn.setAttribute('data-id', id);
    btn.setAttribute('data-source', source);
    btn.appendChild(heartIcon());
    setButton(btn, on);
    return btn;
  }

  function handleSet() {
    var set = {};
    read().forEach(function (i) {
      set[i.h] = true;
    });
    return set;
  }

  function sync() {
    var list = read();
    var set = {};
    list.forEach(function (i) {
      set[i.h] = true;
    });
    var buttons = document.querySelectorAll('.bbdp-wish-btn[data-handle]');
    for (var b = 0; b < buttons.length; b++) {
      setButton(buttons[b], !!set[buttons[b].getAttribute('data-handle')]);
    }
    var link = document.getElementById('bbdp-wish-link');
    if (link) {
      var bubble = link.querySelector('.bbdp-wish-count');
      bubble.textContent = list.length > 99 ? '99+' : String(list.length);
      bubble.hidden = list.length === 0;
    }
    prunePage(set, list.length);
  }

  /* ---------- Montage : cartes, fiche produit, en-tete ---------- */

  function mountCards() {
    var slots = document.querySelectorAll('[data-bbdp-wishlist-slot]:not([data-bbdp-ready])');
    if (!slots.length) return;
    var set = handleSet();
    for (var s = 0; s < slots.length; s++) {
      var slot = slots[s];
      var handle = slot.getAttribute('data-product-handle');
      slot.setAttribute('data-bbdp-ready', '');
      if (!handle) continue;
      var btn = makeButton(handle, slot.getAttribute('data-product-id'), 'card', !!set[handle]);
      var info = cfg.cards === 'below' && slot.parentNode ? slot.parentNode.querySelector('.bbdp-card-info') : null;
      if (info) {
        info.appendChild(btn);
      } else {
        slot.appendChild(btn);
      }
    }
  }

  function mountProduct() {
    if (!cfg.product || !cfg.product.handle) return;
    if (document.querySelector('.bbdp-wish-btn--pdp')) return;
    var main = document.getElementById('MainContent') || document;
    var title = main.querySelector('.product__info-container div.product__title') || main.querySelector('div.product__title');
    var btn = makeButton(cfg.product.handle, cfg.product.id, 'product', has(cfg.product.handle));
    btn.className += ' bbdp-wish-btn--pdp';
    if (title) {
      title.appendChild(btn);
      return;
    }
    var h1 = main.querySelector('h1');
    if (h1 && h1.parentNode) {
      btn.className += ' bbdp-wish-btn--inline';
      h1.parentNode.insertBefore(btn, h1.nextSibling);
    }
  }

  function mountHeader() {
    if (document.getElementById('bbdp-wish-link')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var link = document.createElement('a');
    link.id = 'bbdp-wish-link';
    link.href = root + 'pages/wishlist';
    link.className = 'header__icon header__icon--wishlist link focus-inset';
    link.appendChild(heartIcon());
    var label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = t('title', 'Ma wishlist');
    link.appendChild(label);
    var bubble = document.createElement('span');
    bubble.className = 'cart-count-bubble bbdp-wish-count';
    bubble.setAttribute('aria-hidden', 'true');
    var count = read().length;
    bubble.textContent = count > 99 ? '99+' : String(count);
    bubble.hidden = count === 0;
    link.appendChild(bubble);
    cart.parentNode.insertBefore(link, cart);
  }

  /* ---------- Donnees produit et Klaviyo ---------- */

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error('product ' + response.status);
        return response.json();
      });
      cache[handle].catch(function () {
        delete cache[handle];
      });
    }
    return cache[handle];
  }

  function imageUrl(src, width) {
    var url = String(src || '');
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function marketingConsent(callback) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.marketingAllowed === 'function') {
      callback(!!api.marketingAllowed());
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        var loaded = window.Shopify.customerPrivacy;
        callback(!error && !!loaded && typeof loaded.marketingAllowed === 'function' && !!loaded.marketingAllowed());
      });
      return;
    }
    callback(false);
  }

  /* Envoye uniquement si le consentement marketing est donne dans la banniere Shopify. */
  function track(handle, source) {
    if (!cfg.klaviyo) return;
    marketingConsent(function (allowed) {
      if (!allowed) return;
      fetchProduct(handle)
        .then(function (p) {
          if (!p) return;
          window._learnq = window._learnq || [];
          window._learnq.push([
            'track',
            'Added to Wishlist',
            {
              Name: p.title,
              ProductID: p.id,
              Handle: p.handle,
              URL: window.location.origin + root + 'products/' + p.handle,
              ImageURL: imageUrl(p.featured_image, 600),
              Price: p.price / 100,
              CompareAtPrice: p.compare_at_price ? p.compare_at_price / 100 : null,
              ProductType: p.type || '',
              Available: !!p.available,
              Source: source
            }
          ]);
        })
        .catch(function () {});
    });
  }

  /* ---------- Page Ma wishlist ---------- */

  function group(value, separator) {
    var out = '';
    for (var i = 0; i < value.length; i++) {
      if (i > 0 && (value.length - i) % 3 === 0) out += separator;
      out += value.charAt(i);
    }
    return out;
  }

  function amount(cents, decimals, thousands, decimalMark) {
    var parts = (cents / 100).toFixed(decimals).split('.');
    var text = group(parts[0], thousands);
    return parts.length > 1 ? text + decimalMark + parts[1] : text;
  }

  function money(cents) {
    var format = String(cfg.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    var start = format.indexOf('{{');
    var end = format.indexOf('}}');
    if (start < 0 || end < start) return amount(cents, 2, '.', ',');
    var key = format.slice(start + 2, end).trim();
    var value;
    if (key === 'amount_no_decimals') value = amount(cents, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') value = amount(cents, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') value = amount(cents, 0, '.', ',');
    else if (key === 'amount_with_space_separator') value = amount(cents, 2, ' ', ',');
    else if (key === 'amount_no_decimals_with_space_separator') value = amount(cents, 0, ' ', ',');
    else if (key === 'amount_with_apostrophe_separator') value = amount(cents, 2, '’', '.');
    else value = amount(cents, 2, ',', '.');
    return format.slice(0, start) + value + format.slice(end + 2);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function addToCart(variantId, btn, msg) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { id: variantId, quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        body.sections = drawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
      } catch (e) {
        delete body.sections;
      }
    }
    btn.disabled = true;
    msg.textContent = '';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          msg.textContent = result.json.description || result.json.message || t('error', 'Une erreur est survenue. Merci de réessayer.');
          return;
        }
        msg.textContent = t('added', 'Ajouté au panier');
        try {
          if (drawer && body.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(result.json);
            return;
          }
        } catch (e) {
          /* on retombe sur la page panier */
        }
        window.location.href = root + 'cart';
      })
      .catch(function () {
        msg.textContent = t('error', 'Une erreur est survenue. Merci de réessayer.');
      })
      .then(function () {
        btn.disabled = false;
      });
  }

  function buildItem(p) {
    var url = root + 'products/' + p.handle;
    var li = el('li', 'bbdp-wl-item');
    li.setAttribute('data-handle', p.handle);

    var media = el('a', 'bbdp-wl-item__media');
    media.href = url;
    media.setAttribute('tabindex', '-1');
    media.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imageUrl(p.featured_image, 533);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 533;
      img.height = 533;
      media.appendChild(img);
    }
    li.appendChild(media);
    li.appendChild(makeButton(p.handle, p.id, 'wishlist', true));
    if (!p.available) li.appendChild(el('span', 'bbdp-wl-item__badge', t('soldout', 'Épuisé')));

    var head = el('div', 'bbdp-wl-item__head');
    var title = el('a', 'bbdp-wl-item__title', p.title);
    title.href = url;
    head.appendChild(title);
    var price = el('div', 'bbdp-wl-item__price');
    if (p.compare_at_price && p.compare_at_price > p.price) price.appendChild(el('s', '', money(p.compare_at_price)));
    price.appendChild(el('span', '', money(p.price)));
    head.appendChild(price);
    li.appendChild(head);

    var actions = el('div', 'bbdp-wl-item__actions');
    var msg = el('p', 'bbdp-wl-item__msg');
    msg.setAttribute('role', 'status');
    var variants = p.variants || [];

    if (p.available && variants.length) {
      var select = null;
      if (variants.length > 1) {
        var optionName = p.options && p.options.length === 1 && p.options[0] && p.options[0].name ? p.options[0].name : t('size', 'Pointure');
        select = el('select', 'bbdp-wl-item__select');
        select.setAttribute('aria-label', optionName);
        var placeholder = el('option', '', optionName);
        placeholder.value = '';
        placeholder.selected = true;
        select.appendChild(placeholder);
        variants.forEach(function (variant) {
          var option = el('option', '', variant.available ? variant.title : variant.title + ' — ' + t('soldout', 'Épuisé'));
          option.value = variant.id;
          if (!variant.available) option.disabled = true;
          select.appendChild(option);
        });
        actions.appendChild(select);
      }
      var addBtn = el('button', 'button button--primary bbdp-wl-item__add', t('add_to_cart', 'Ajouter au panier'));
      addBtn.type = 'button';
      addBtn.addEventListener('click', function () {
        var variantId = select ? select.value : variants[0].id;
        if (!variantId) {
          msg.textContent = t('choose', 'Choisissez une pointure');
          if (select) select.focus();
          return;
        }
        addToCart(variantId, addBtn, msg);
      });
      actions.appendChild(addBtn);
    } else {
      var view = el('a', 'button button--secondary bbdp-wl-item__add', t('view', 'Voir le produit'));
      view.href = url;
      actions.appendChild(view);
    }
    actions.appendChild(msg);
    li.appendChild(actions);
    return li;
  }

  function pageParts() {
    var page = document.getElementById('bbdp-wishlist-page');
    if (!page) return null;
    return {
      page: page,
      list: page.querySelector('[data-list]'),
      empty: page.querySelector('[data-empty]'),
      note: page.querySelector('[data-note]')
    };
  }

  function prunePage(set, count) {
    var parts = pageParts();
    if (!parts || !parts.list) return;
    var rows = parts.list.querySelectorAll('.bbdp-wl-item');
    for (var r = 0; r < rows.length; r++) {
      if (!set[rows[r].getAttribute('data-handle')]) parts.list.removeChild(rows[r]);
    }
    if (parts.empty && parts.page.getAttribute('data-rendered') === 'true') parts.empty.hidden = count > 0;
  }

  function renderPage() {
    var parts = pageParts();
    if (!parts || !parts.list) return;
    var items = read();
    if (!items.length) {
      parts.page.setAttribute('data-rendered', 'true');
      if (parts.empty) parts.empty.hidden = false;
      return;
    }
    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.h).then(
          function (product) {
            return { item: item, product: product };
          },
          function () {
            return { item: item, product: undefined };
          }
        );
      })
    ).then(function (results) {
      var gone = 0;
      parts.list.textContent = '';
      results.forEach(function (result) {
        if (result.product === null) {
          gone++;
          remove(result.item.h);
          return;
        }
        if (!result.product) return;
        parts.list.appendChild(buildItem(result.product));
      });
      if (gone && parts.note) {
        parts.note.textContent = gone === 1 ? t('gone_one', 'Un article n’est plus disponible et a été retiré de votre liste.') : t('gone_many', 'Des articles ne sont plus disponibles et ont été retirés de votre liste.');
        parts.note.hidden = false;
      }
      parts.page.setAttribute('data-rendered', 'true');
      sync();
    });
  }

  /* ---------- Evenements ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('.bbdp-wish-btn[data-handle]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (has(handle)) {
      remove(handle);
    } else {
      add(handle, btn.getAttribute('data-id'));
      track(handle, btn.getAttribute('data-source') || 'card');
    }
    sync();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) sync();
  });

  function init() {
    mountHeader();
    mountCards();
    mountProduct();
    renderPage();
    if (window.MutationObserver && document.body) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          mountHeader();
          mountCards();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.BBDPWishlist = { list: read, has: has, add: add, remove: remove, refresh: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
